<template>  
  <v-container fluid>
    <v-dialog v-model="showDialog" scrollable max-width="850px" style="z-index: 1019;">
      <v-card>
        <v-card-title style="padding: 10px 0 0 10px">
          <v-col cols="12">
            <v-row justify="start" align="center">
              <span style="font-size: 20px">
                {{ isNew ? $t('wkt.admin.projects.calendar.by-section-window.new_title') : $t('wkt.admin.projects.calendar.by-section-window.edit_title') }}
              </span>
            </v-row>
          </v-col>
        </v-card-title>
        <v-card-text class="pb-3">
          <v-container fluid @wheel="onWheel">
            <v-form ref="form">
              <v-row>
                <v-col cols="3">
                  <v-text-field
                    v-model="data.periodicityInDays"
                    :rules="[validationRules.required, validationRules.minValue(1)]"
                    :label="$t('wkt.admin.projects.calendar-wizard.periodicity_days')"
                    type="number"
                    min="1"
                    max="365"
                  />
                </v-col>
                <v-col cols="12">
                  <v-autocomplete
                    attach
                    v-model="data.project"
                    :items="projects"
                    item-text="shortName"
                    item-value="id"
                    :rules="[validationRules.required]"
                    :label="$t('wkt.admin.projects.calendar-wizard.project_title')"
                    allow-overflow
                    @change="onProjectChange"
                  />
                </v-col>
                <v-col cols="12">
                  <v-autocomplete
                    attach
                    v-model="data.calendar"
                    :items="calendars"
                    item-text="name"
                    item-value="id"
                    :rules="[validationRules.required]"
                    :label="$t('wkt.admin.projects.calendar-wizard.calendar_title')"
                    allow-overflow
                  />
                </v-col>
                <v-col cols="12">
                  <v-autocomplete
                    attach
                    v-model="data.workplace"
                    :items="workplaces"
                    item-text="name"
                    item-value="id"
                    :rules="[validationRules.required]"
                    :label="$t('wkt.admin.projects.calendar-wizard.workplace_title')"
                    class="mr-2"
                    style="width: 100%"
                    allow-overflow
                  />
                </v-col>
                <v-col cols="12" class="py-0">
                  <v-checkbox
                    v-model="data.isTelework"
                    :label="$t('wkt.admin.dailyreports.edit-workday-window.telework')"
                    class="mt-0"
                    hide-details
                    color="#185EA9"
                  />
                </v-col>
                <v-col cols="12">
                  <v-textarea
                    v-model="data.notes"
                    :label="$t('wkt.admin.calendar.wizard-window.description')"
                    class="pt-0"
                    autocomplete="none" 
                    auto-grow 
                    rows="1"
                    @wheel="onWheel"
                    maxLength="200"
                    counter="200"
                  />
                </v-col>
              </v-row>
            </v-form>
          </v-container>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-btn v-if="!isNew" color="#ff0000" @click="confirmDelete()">
            <v-icon left color="#ffffff">delete</v-icon>
            <span style="color: #ffffff;">
              {{ $t('wkt.admin.common.dialog-buttons.delete').toUpperCase() }}
            </span>
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn color="#185EA9" text @click="onSave()" style="font-size: 0.9em; font-weight: 400">
            {{ $t("wkt.admin.common.dialog-buttons.save").toUpperCase() }}
          </v-btn>
          <v-btn text @click="showDialog = false" style="font-size: 0.9em; font-weight: 400">
            {{ $t("wkt.admin.common.dialog-buttons.cancel").toUpperCase() }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <ConfirmDialog
      ref='dlgConfirm'
      :title="$t('wkt.admin.calendar.wizard-window.confirm-dialog.title')"
      :message="$t('wkt.admin.calendar.wizard-window.confirm-dialog.text')"
      :titleOk="$t('wkt.admin.common.dialog-buttons.delete')"
      :titleCancel="$t('wkt.admin.common.dialog-buttons.cancel')"
      @confirmed="deleteItem()"
    />  
  </v-container>
</template>

<script>
import BaseModule from "../../common/BaseModule.js";
import ConfirmDialog from "../../common/ConfirmDialog.vue";

export default {
  name: "ProjectCalendarBySectionDialog",
  mixins: [BaseModule],
  components: {
    ConfirmDialog
  },
  data() {
    return {
      showDialog: false,
      isNew: false,
      projectId: null,
      data: {},
      projects: [],
      calendars: [],
      workplaces: [], 
      msgCb: null 
    };
  },
  methods: {
    onWheel(event) {
      event.stopPropagation();
    },
    open(data, projects, calendars, workplaces, msgCb) {
      this.projectId = null;
      this.calendars = calendars;
      this.projects = projects;
      this.workplaces = workplaces;
      this.msgCb = msgCb;

      if (!data) {
        this.data = {
          periodicityInDays: 1, 
          project: -1, 
          calendar: -1, 
          workplace: -1,
          isTelework: false,
          notes: null
        };
        this.isNew = true;
        this.showDialog = true;
        return;
      } 
      
      this.data = {
        ...data,
        isTelework: data.isTelework === true
      };
      this.isNew = false;
      this.showDialog = true;
      
      if (this.$refs.form) {
        this.$refs.form.resetValidation();
      }
    },    
    onProjectChange(projectId) {
      this.projectId = projectId;
    },
    validate() {
      return true;
    },
    onSave() { 
      if (!this.$refs.form.validate()) {
        return;
      }
      
      if (this.msgCb) {
        this.msgCb({ type: (this.isNew ? 'add' : 'edit'), data: this.data, projectId: this.projectId });
      }
      
      this.showDialog = false;
    },
    confirmDelete() {
      this.$refs.dlgConfirm.confirm(this.data);
    },
    deleteItem() {      
      if (this.msgCb) {
        this.msgCb({ type: 'delete', data: null, projectId: this.projectId });
      }
      
      this.showDialog = false;
    }
  }
}
</script>